// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1477":"82ac9fed","2172":"011a75d9","4671":"011a75d9","6681":"14195b3d"}[chunkId] + ".chunk.css";
};